import { useState } from 'react';
import { validateCreditCardField } from '../payment/CreditCardForm';

/**
 * A hook to manage the state of the CreditCardForm component
 */
const useCreditCardForm = (props) => {
	const defaultCreditCardForm = {
		cardNo: { value: '' },
		cardCvv: { value: '' },
		cardExpDate: { value: '' },
		cardholderName: { value: '' },
		cardZipCode: { value: '' }
	};

	const [creditCardForm, setCreditCardForm] = useState(props?.initialCreditCardForm || defaultCreditCardForm);

	/**
	 * Validate credit card input field changes and update state
	 * @param event The HTML event that triggered this method
	 */
	const handleCreditCardFieldChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const valid = target.type === 'checkbox' ? true : !!value || false;
		const fieldName = target.name;

		let newField = {
			value: value,
			valid: valid
		};

		// Only validate when the value is empty. We don't want to do other validation like credit card length
		// when typing in the field
		newField.message = value ? '' : validateCreditCardField(fieldName, newField).message;

		setCreditCardForm((prevState) => ({
			...prevState,
			[fieldName]: newField
		}));
	};

	return { creditCardForm, setCreditCardForm, handleCreditCardFieldChange };
};

export { useCreditCardForm };
